export const OPEN_WINDOW:'OPEN_WINDOW' = 'OPEN_WINDOW';
export const OPEN_WINDOW_ONCE:'OPEN_WINDOW_ONCE' = 'OPEN_WINDOW_ONCE';
export const RESIZE_WINDOW:'RESIZE_WINDOW' = 'RESIZE_WINDOW';
export const REPOSITION_WINDOW:'REPOSITION_WINDOW' = 'REPOSITION_WINDOW';
export const TO_ACTIVE_WINDOW:'TO_ACTIVE_WINDOW' = 'TO_ACTIVE_WINDOW';
export const TO_ACTIVE_SCREEN_WINDOW:'TO_ACTIVE_SCREEN_WINDOW' = 'TO_ACTIVE_SCREEN_WINDOW';
export const TO_DISACTIVE_SCREEN_WINDOW:'TO_DISACTIVE_SCREEN_WINDOW' = 'TO_DISACTIVE_SCREEN_WINDOW';
export const TO_DISACTIVE_WINDOWS:'TO_DISACTIVE_WINDOWS' = 'TO_DISACTIVE_WINDOWS';
export const TO_EXPAND_WINDOW:'TO_EXPAND_WINDOW' = 'TO_EXPAND_WINDOW';
export const TO_COLLAPSE_WINDOW:'TO_COLLAPSE_WINDOW' = 'TO_COLLAPSE_WINDOW';
export const CLOSE_WINDOW:'CLOSE_WINDOW' = 'CLOSE_WINDOW';